import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { TRANSLATIONS_ES } from './translations.es';
import { TRANSLATIONS_EN } from './translations.en';
import { TRANSLATIONS_PT } from './translations.pt';
import { TRANSLATIONS_FR } from './translations.fr';
import { TRANSLATIONS_JA } from "./translations.jp";

export type Language = "es" | "en" | "pt" | "fr" | "ja";

interface Translations {
  [key: string]: {
    [key: string]: string;
  };
}

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  private translations: Translations = {
    es: TRANSLATIONS_ES,
    en: TRANSLATIONS_EN,
    pt: TRANSLATIONS_PT,
    fr: TRANSLATIONS_FR,
    ja: TRANSLATIONS_JA,
  };

  private currentLangSubject = new BehaviorSubject<Language>(
    this.getInitialLanguage()
  );
  public currentLang$ = this.currentLangSubject.asObservable();

  constructor() {}

  private getInitialLanguage(): Language {
    // Verificar si hay un idioma guardado en localStorage
    const savedLang = localStorage.getItem("language") as Language;
    if (savedLang && (savedLang === "es" || savedLang === "en" || savedLang === "pt" 
        || savedLang === "fr" || savedLang === "ja")) {
      return savedLang;
    }

    // Por defecto, usar español
    return "es";
  }

  public setLanguage(lang: Language): void {
    this.currentLangSubject.next(lang);
    localStorage.setItem("language", lang);
  }

  public translate(key: string): string {
    const currentLang = this.currentLangSubject.value;
    return this.translations[currentLang][key] || key;
  }
  public getCurrentLang(): Language {
    return this.currentLangSubject.value;
  }
}
